import React from 'react';

// import './home.css';
import CoreExamples from '../components/CoreExamples';

function HomePage() {


  return (
    <>
      <CoreExamples />
    </>

  );
}

export default HomePage;